/* eslint-disable sort-keys */
/* eslint-disable import/prefer-default-export */
import React from 'react'

import {
  Awerness,
  BeforeAfterSteps,
  BlogContentSection,
  BlogTipsSection,
  BrindusaSection,
  CategoryContentSection,
  CategoryListingSection,
  ContentMedia,
  Cta,
  Doctors,
  Experience,
  Faq,
  Hero,
  LatestBlogsSection,
  Map,
  NewtIntro,
  Pricing,
  PricingDetails,
  QualityContent,
  Quote,
  Reviews,
  ReviewWidget,
  StepsContainer,
  Treatment,
  TreatmentDetailsSection,
  TreatmentIntro,
  TreatmentResults,
  TreatmentsListSection,
  Trust,
} from '../sections'
import GoogleReviews from '../sections/GoogleReviews/GoogleReviews'
import HeroCarousel from '../sections/HeroCarousel/HeroCarousel'
import MothersCta from '../sections/MothersCta/MothersCta'
import MothersDayUsp from '../sections/MothersDayUsp/MothersDayUsp'
import MothersGiftInfo from '../sections/MothersGiftInfo/MothersGiftInfo'
import PromotedTreatments from '../sections/PromotedTreatments/PromotedTreatments'

const sliceComponents = {
  herocarousel: HeroCarousel,
  herocontent: Hero,
  quotecontent: Quote,
  awernesssection: Awerness,
  treatmentsintrocontent: Treatment,
  stepssectioncontent: StepsContainer,
  teamsectioncontent: Doctors,
  reviewsectioncontent: Reviews,
  trustsection: Trust,
  experiencesectioncontent: Experience,
  ctasectioncontent: Cta,
  mediasectioncontent: ContentMedia,
  treatmentintrosection: NewtIntro,
  contactintro: TreatmentIntro,
  bloglistingsection: LatestBlogsSection,
  biopagehero: BrindusaSection,
  categorylistingsection: CategoryListingSection,
  categorycontentsection: CategoryContentSection,
  faqsectioncontent: Faq,
  mapsectioncontent: Map,
  qualitycontentsection: QualityContent,
  blogcontent: BlogContentSection,
  blogtipssection: BlogTipsSection,
  pricedetailscontent: PricingDetails,
  treatmentlistsection: TreatmentsListSection,
  beforeaftersection: BeforeAfterSteps,
  treatmentdetailssection: TreatmentDetailsSection,
  treatmentresultsection: TreatmentResults,
  treatmentpricingsection: Pricing,
  reviewSliderWidget: ReviewWidget,
  promotedTreatments: PromotedTreatments,
  mothersdayuspsection: MothersDayUsp,
  googleReviews: GoogleReviews,
  mothersdaycta: MothersCta,
  mothersgiftinfo: MothersGiftInfo,
}

export const SliceRenderer = ({ isSurgery, lang, pageType, slices, url }) => {
  return slices.map((slice, index) => {
    const compontentName =
      pageType === 'contact' &&
      slice?.fieldGroupName === 'treatmentintrosection'
        ? 'contactintro'
        : slice?.fieldGroupName
    const Component = sliceComponents[compontentName]
    if (Component) {
      return (
        <Component
          // eslint-disable-next-line react/no-array-index-key
          key={`slice-${index}`}
          component={slice.fieldGroupName}
          isSurgery={isSurgery}
          lang={lang}
          pageType={pageType}
          slice={slice}
          url={url}
        />
      )
    }
    return null
  })
}
